/**
 * @module linkage/chartTypeSwitch/applyChartTypeLinkage
 * @description QB 顶栏切图：prepare + 同步 MERGE_QB_PATCH（唯一写入点）
 */

import type { Dispatch } from 'react';
import { CSActionType, type TCSAction } from '../../types';
import {
  prepareConfigForChartType,
  type IPrepareConfigInput,
  type IPrepareConfigOutput,
} from './prepareConfigForChartType';

export function applyChartTypeLinkage(
  dispatch: Dispatch<TCSAction>,
  input: IPrepareConfigInput,
): IPrepareConfigOutput {
  const prepared = prepareConfigForChartType(input);

  if (
    Object.keys(prepared.basePatch).length ||
    Object.keys(prepared.draftPatch).length
  ) {
    dispatch({
      type: CSActionType.MERGE_QB_PATCH,
      payload: {
        base: Object.keys(prepared.basePatch).length
          ? prepared.basePatch
          : undefined,
        draft: Object.keys(prepared.draftPatch).length
          ? prepared.draftPatch
          : undefined,
      },
    });
  }

  return prepared;
}
